import { LoadingButton } from "@mui/lab";
import {
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ServiceApi } from "../../services/index.service";
import { useSelector } from "react-redux";
import ShowDescriptionModal from "./ShowDescriptionModal";
import { enqueueSnackbar } from "notistack";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
const defaultVendorDesc = {
  show: false,
  data: "",
};
const VendorItem = (props) => {
  const [isSquare, setIsSquare] = useState(false);
  const { vendorItem } = props;
  const [orderNowItem, setOrderNowItem] = useState({
    intVendorGatewayID: 0,
    loading: false,
  });
  const [vendorDesc, setVendorDesc] = useState(defaultVendorDesc);
  const hiddenFieldRef = useRef(null);
  const formRef = useRef(null);
  const serviceapi = new ServiceApi();
  const { profile, storage } = useSelector((state) => state);
  const handleAuthorization = async (e, dataItem) => {
    e.preventDefault();
    const req = {
      RitasStoreID: storage?.store?.intRitasStoreID,
      intVendorGatewayID: dataItem?.intVendorGatewayID,
      userName: profile?.user_name,
    };
    setOrderNowItem({
      intVendorGatewayID: dataItem?.intVendorGatewayID,
      loading: true,
    });
    const res = await serviceapi?.getOnlinevendorauthorizationdetails(req);
    setOrderNowItem({
      intVendorGatewayID: 0,
      loading: false,
    });
    if (res?.data?.success) {
      if (res?.data?.url) {
        window.open(res?.data?.url, "_blank");
      } else {
        hiddenFieldRef.current.value = res?.data?.token;
        formRef.current.submit();
      }
    } else {
      enqueueSnackbar(res?.data?.message, {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "error",
      });
    }
  };
  const handleShowMore = (dataItem) => {
    setVendorDesc({
      show: true,
      data: dataItem,
    });
  };

  const handleCloseDialog = () => {
    setVendorDesc(defaultVendorDesc);
  };
  let loader = false;
  if (
    orderNowItem?.loading &&
    vendorItem?.intVendorGatewayID === orderNowItem?.intVendorGatewayID
  ) {
    loader = true;
  }

  useEffect(() => {
    const img = new Image();
    img.src = vendorItem?.vchVendorImage;
    img.onload = () => {
      const tolerance = 5; // Allow up to 5px difference
      setIsSquare(Math.abs(img.width - img.height) <= tolerance);
    };
    // Custom form submission for 'Tukaiz' Vendor
    if (`${vendorItem?.vchVendorName}`.toLowerCase().includes('tukaiz')) {
      const form = document.getElementById(`searchForm${vendorItem?.intVendorGatewayID}`);

      const handleFormSubmit = (event) => {
        event.preventDefault();
        const tempForm = document.createElement('form');
        tempForm.method = form.method;
        tempForm.action = form.action;
        tempForm.target = "_blank";

        console.log(`URL: ${tempForm.action};  Method: ${tempForm.method}; FieldsCount: ${tempForm.childElementCount}`);
        document.body.appendChild(tempForm);
        tempForm.submit();
        document.body.removeChild(tempForm);
      }
      form.addEventListener('submit', handleFormSubmit);
      return () => {
        form.removeEventListener('submit', handleFormSubmit);
      }
    }
  }, []);

  return (
    <>
      <Card
        style={{
          height: "fit-content",
          border: "#FFF5F5",
          borderWidth: "1px",
          background: "#fff",
          borderRadius: "4px",
        }}
      >
        <form
          ref={formRef}
          name={`searchForm${vendorItem?.intVendorGatewayID}`}
          id={`searchForm${vendorItem?.intVendorGatewayID}`}
          action={vendorItem?.vchVendorURL}
          target="_blank"
          method={vendorItem?.vchPost}
        >
          <div className="flex flex-column py-3 px-1 vendor-name-tour-selector">
            <div
              style={{
                width: isSquare ? "25%" : "50%",
                height: "48px",
                display: "flex",
              }}
            >
              <img
                src={vendorItem?.vchVendorImage}
                style={{
                  display: "inline-block",
                  position: "relative",
                  padding: isSquare ? "8px 8px" : "3px 3px",
                  overflow: "hidden",
                  alignSelf: "center",
                  objectFit: isSquare ? "cover" : "contain", // Cover for square, Contain for rectangle
                }}
                alt="vendor"
              />
    </div>
            <Typography
              sx={{
                color: "#044A2A",
                fontWeight: "600",
                fontSize: "16px",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                alignSelf: "center",
              }}
            >
              {vendorItem?.vchVendorName}
            </Typography>
          </div>
          <hr />
          <CardContent style={{ minHeight: "9rem" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.9rem",
              }}
            >
              <div className="vendor-contact-tour-selector">
                <Typography
                  variant="body2"
                  color="#332F2D"
                  style={{ display: "flex", textOverflow: "ellipsis" }}
                >
                  <span className="pr-3">
                    {" "}
                    <img
                      className="EmailIcon"
                      style={{ width: "20px" }}
                      src={"../../assets/icons/emailIcon.svg"}
                      alt="emailIcon"
                    />{" "}
                  </span>
                  {!vendorItem?.vchEmail || vendorItem?.vchEmail !== "NA" ? (
                    <span className="vendor-email">{vendorItem?.vchEmail}</span>
                  ) : (
                    "N/A"
                  )}
                </Typography>
                {vendorItem?.vchPhoneNumber ? <Typography
                  variant="body2"
                  color="#332F2D"
                  style={{ display: "flex" }}
                  marginTop={'0.9rem'}
                >
                  <span className="pr-3">
                    <img
                      style={{ width: "20px" }}
                      src={"../../assets/icons/phone.svg"}
                      alt="emailIcon"
                    />{" "}
                  </span>
                  <span className="vendor-phone">
                    {!vendorItem?.vchPhoneNumber ||
                      vendorItem?.vchPhoneNumber !== "NA"
                      ? vendorItem?.vchPhoneNumber
                      : "N/A"}
                  </span>
                </Typography> : <div className="h-5"></div>}
              </div>
              <div className="flex gap-6 items-center">
                <span
                  style={{ display: "end" }}
                  className="show-desc vendor-description-tour-selector"
                  onClick={() => handleShowMore(vendorItem)}
                >
                  Show Description
                </span>
                <span className="vendor-category-tour-selector">
                  <Chip
                    size="small"
                    label={vendorItem?.vchCategory}
                    className="chip-category"
                  />
                </span>
              </div>
            </div>
          </CardContent>
          {/* <hr style={{background:'#FFF8F8',borderColor:'#FFF5F5',borderWidth:'1px',}}/> */}
          {/* <Divider orientation="horizontal" variant="middle" flexItem /> */}
          <Divider variant="#FFF8F8" />
          <CardActions
            style={{
              maxHeight: "4rem",
              background: "#FFF8F8",
              borderColor: "#FFF5F5",
              borderWidth: "1px",
            }}
          >
            <div className="flex justify-between w-full">
              <div className="flex">
                {props?.isAdmin ? (
                  <>
                    <IconButton
                      disabled={vendorItem?.vchAuthorizer}
                      style={{
                        opacity: vendorItem?.vchAuthorizer ? "0.5" : "1",
                      }}
                      onClick={() => props?.handleAddFields(vendorItem)}
                    >
                      <img
                        src={"../../assets/images/add-vendor-fields.svg"}
                        alt="add-vendor-fields"
                      />
                    </IconButton>
                    <IconButton onClick={() => props?.handleEdit(vendorItem)}>
                      <img
                        src={"../../assets/images/edit-vendor.svg"}
                        alt="edit-vendor"
                      />
                    </IconButton>
                    <IconButton onClick={() => props?.handleDelete(vendorItem)}>
                      <img
                        src={"../../assets/images/delete-vendor.svg"}
                        alt="delete-vendor"
                      />
                    </IconButton>
                  </>
                ) : null}
              </div>
              {props?.isAdmin ? <Divider orientation="vertical" variant="middle" flexItem /> : null}
              {!vendorItem?.vchAuthorizer &&
                Object?.keys(vendorItem?.fields)?.length > 0 &&
                Object?.keys(vendorItem?.fields)?.map((j, index) => {
                  return (
                    <input
                      key={index}
                      type="hidden"
                      name={j}
                      value={vendorItem?.fields?.[j]}
                    ></input>
                  );
                })}
              <div className="vendor-order-button-tour-selector">
                {vendorItem?.vchAuthorizer ? (
                  <>
                    <input type="hidden" name="token" ref={hiddenFieldRef} />
                    <input
                      type="hidden"
                      name="Username"
                      value={`store4${storage?.store?.intRitasStoreID
                        ?.toString()
                        .padStart(4, "0")
                        .replace(/ /g, "0")}`}
                    />
                    <input
                      type="submit"
                      style={{ display: "none" }}
                      value="Submit Form"
                    />
                    <LoadingButton
                      variant="outlined"
                      style={{
                        textTransform: "capitalize",
                        background: loader ? "#D41042" : "white",
                        color: loader ? "white" : "#D41042",
                      }}
                      disabled={loader ? true : false}
                      loading={loader ? true : false}
                      onClick={(e) => handleAuthorization(e, vendorItem)}
                      className="inline-flex items-center justify-center rounded-md border border-primary border-2 bg-white px-4 py-2 text-sm font-bold text-primary shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
                    >
                      Order Now
                    </LoadingButton>
                  </>
                ) : (
                  <button
                    type="submit"
                    className="inline-flex items-center justify-center rounded-md border-2 border-[#D41042] bg-white px-4 py-2 text-sm font-bold text-[#D41042] shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
                  >
                    Order Now
                  </button>
                )}
              </div>
            </div>
          </CardActions>
        </form>
      </Card>
      {vendorDesc?.show ? (
        <ShowDescriptionModal
          handleCloseDialog={handleCloseDialog}
          dataItem={vendorDesc?.data}
        />
      ) : null}
    </>
  );
};

export default VendorItem;
